export function timeDifference(current: number, previous: number): string {

  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  const elapsed = current - previous;

  if (elapsed < msPerMinute) {
    return 'just now';
  }

  else if (elapsed < msPerHour) {
    return Math.round(elapsed/msPerMinute) + 'm';
  }

  else if (elapsed < msPerDay ) {
    return Math.round(elapsed/msPerHour ) + 'h';
  }

  else if (elapsed < msPerMonth) {
    return Math.round(elapsed/msPerDay) + 'd';
  }

  else if (elapsed < msPerYear) {
    return Math.round(elapsed/msPerMonth) + 'mo';
  }

  else {
    return Math.round(elapsed/msPerYear ) + 'y';
  }
}

export function relativeDay (dateTime: number): string {
  const date = new Date(dateTime);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return "Today";
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  } else {
    if (today.getTime() - date.getTime() < 7 * 24 * 60 * 60 * 1000) {
      return date.toLocaleDateString("en-US", { weekday: 'long' });
    } else {
      return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
    }
  }
}